module.exports = __webpack_public_path__ + "img/sp_foot_ico05_active.9b4bc6bd.svg";